import { render, staticRenderFns } from "./MyQuotationConfirm.vue?vue&type=template&id=49a229d6&"
import script from "./MyQuotationConfirm.vue?vue&type=script&lang=js&"
export * from "./MyQuotationConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a229d6')) {
      api.createRecord('49a229d6', component.options)
    } else {
      api.reload('49a229d6', component.options)
    }
    module.hot.accept("./MyQuotationConfirm.vue?vue&type=template&id=49a229d6&", function () {
      api.rerender('49a229d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationConfirm.vue"
export default component.exports